import { Identified } from "@/types/sdk-types";
import { useQuery } from "@tanstack/react-query";
import { ProviderGroupControllerApi, ProviderGroup } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  enabled?: boolean;
}

/**
 * Verified sender address configured for the practice (Practice Settings >
 * Configuration). The multipart send-email-with-attachment endpoint takes the
 * sender as a parameter, unlike send-email which resolves it server side.
 *
 * Shares its query key with useGetConfigurationDetailsByName so the config is
 * fetched once; this wrapper only adds the `enabled` flag, so screens that
 * never send an attachment do not call it at all.
 *
 * @author [Atish Bagate]
 */
export const useProviderGroupSenderEmail = ({
  enabled = true,
}: Props = {}): useBaseContent<Identified<ProviderGroup>> => {
  const providerGroupName = getXtenantId() ?? "";

  return useQuery({
    queryKey: ["configuration-details-by-name", providerGroupName],
    enabled: enabled && !!providerGroupName,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new ProviderGroupControllerApi(getConfigObject())
        .getProviderGroupConfig(providerGroupName, providerGroupName)
        .then((res) => res?.data),
  });
};
